import { render, staticRenderFns } from "./DiarioRptComponent.vue?vue&type=template&id=4b5ee57f&"
import script from "./DiarioRptComponent.vue?vue&type=script&lang=js&"
export * from "./DiarioRptComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports